import React from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'src/features/common';
import { paymentsDashboardRoute } from 'src/routing/routes';

type UpdateInProgressProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

function UpdateInProgress({ show, setShow }: UpdateInProgressProps) {
  const history = useHistory();

  const handleClose = () => {
    setShow(false);
    history.push(paymentsDashboardRoute);
  };

  return (
    <Modal visible={show} size="custom-small" onClose={handleClose}>
      <div className="flex flex-col items-center gap-10">
        <h1 className="text-4xl text-grey-600">Update in progress</h1>
        <p className="w-full max-w-xs text-xl text-center text-grey-400">
          We have an update in progress. Please come back later
        </p>
        <button
          type="button"
          className="w-full max-w-xs text-white bg-red-500 h-11 rounded-40"
          onClick={handleClose}
        >
          Okay!
        </button>
      </div>
    </Modal>
  );
}

export default UpdateInProgress;
